import { AppStore } from 'src/stores/app.store';


/**
 * IStore
 */
interface IStore<S> {
  global: AppStore;

  hydrate(store: S, global: AppStore): void;
}

/**
 * Store Constructor
 */
type StoreConstructor = Function & { [IS_STORE_TYPE]?: boolean };

/**
 * IS_STORE_TYPE
 */
const IS_STORE_TYPE = 'IS_STORE_TYPE';

/**
 * Store decorator
 */
const Store = (constructor: StoreConstructor) => {
  constructor[IS_STORE_TYPE] = true;
};

/**
 * Base Hydrate
 */
const baseHydrate = <S, T>(source: S, target: T | (T & IStore<T>)) => {
  Object.entries(source).forEach(([prop, val]) => {
    (target as Record<string, any>)[prop] = val;
  });
};

export { Store, IS_STORE_TYPE, baseHydrate };

export type { IStore };
